import { render, staticRenderFns } from "./cleaning.vue?vue&type=template&id=4e352499&scoped=true&"
import script from "./cleaning.vue?vue&type=script&lang=js&"
export * from "./cleaning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e352499",
  null
  
)

export default component.exports